module.exports = __webpack_public_path__ + "img/sendgrid-stencil.50d47319.svg";